<template>
  <div>
    <div class="hr-with-text">{{ $t('authentication-app.or') }}</div>
    <Passkey
        @success-otp="$emit('success-otp', $event)"
        @invalid-credential-id-error="$emit('invalid-credential-id-error', $event)"
        @critical-error="$emit('critical-error', $event)"
    />
  </div>
</template>

<script>
import Passkey from '../../components/AlternativeAuthMethods/Passkey/Passkey.vue';
export default {
  name: 'AlternativeAuthMethods',

  components: {
    Passkey,
  }
};
</script>

<style lang="scss" scoped>
.hr-with-text {
  display: flex;
  align-items: center;
  text-align: center;
  color: rgba(0, 0, 0, 0.1);
  margin-top: 45px;

&::before,
&::after {
   content: '';
   flex: 1;
   border-bottom: 1px solid rgba(0, 0, 0, 0.1);
 }

&:not(:empty)::before {
   margin-right: 0.25em;
 }

&:not(:empty)::after {
   margin-left: 0.25em;
 }
}
</style>
